'use es6';

let _ = t => t,
    _t,
    _t2,
    _t3;

import styled from 'styled-components';
import breakpoint from '../../utils/responsiveBreakpoints';
const HubInfoContainer = styled.div.withConfig({
  displayName: "HubInfoContainer",
  componentId: "sc-1ndqe9w-0"
})(["max-width:1280px;margin:0 auto;margin-top:-458px;padding:35px 40px 0;", ";", ";", ";"], breakpoint.tablet(_t || (_t = _`
    padding: 20px 1.3em;
  `)), breakpoint.tabletPortrait(_t2 || (_t2 = _`
    padding: 20px 14px 0;
  `)), breakpoint.phone(_t3 || (_t3 = _`
    padding-top: 20px;
  `)));
export default HubInfoContainer;